export default __webpack_public_path__ + "static/media/create_edit_subamministratore.cd66c1d8.less";